import React from 'react';

import {
    withInterstitial,
} from 'wanderu-component-page-loader';
import { Redirect as AppRedirect } from 'wanderu-component-react-router-link';

const AppPage = withInterstitial(import('./containers/GetTheApp/GetTheApp'));

export default [
    {
        path: '/app/',
        component: AppPage,
        exact: true,
        key: '/app/',
    },
    {
        path: '/app/*',
        key: 'app-catchall',
        component: () => {
            return (
                <AppRedirect href="/app/" />
            );
        },
    },
];
